export default __webpack_public_path__ + "HugoBudillon.34dc47d.jpg";